import { z } from 'zod';

import {
  essayEvolutionResponseSchema,
  type EssayEvolutionResponse,
} from '@/features/benchmarking/schemas/benchmarkingEssayEvolution';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

export const getBenchmarkingEssayEvolutionParamsSchema = z.object({
  escolaId: z.number().int(),
  anoLetivo: z.number().int().optional(),
  anoEscolarId: z.number().int().optional(),
  turmaId: z.number().int().optional(),
  alunoId: z.number().int().optional(),
  categoriaId: z.number().int().optional(),
  nomModelo: z.string().optional(),
});

export type GetBenchmarkingEssayEvolutionParams = z.infer<typeof getBenchmarkingEssayEvolutionParamsSchema>;

export const getBenchmarkingEssayEvolution = httpGetAdapter<
  EssayEvolutionResponse,
  GetBenchmarkingEssayEvolutionParams
>({
  url: (params) => `/v3/microdados/escola/${params.escolaId}/evolucao-redacoes`,
  schema: essayEvolutionResponseSchema,
  mapParams: ({ escolaId: _escolaId, ...rest }) => rest,
});
